<template>
  <div class="m-page">
    <div class="m-page-banner" :style="'background: url(' + currentPageBg.bg + ') no-repeat center; ' + 'background-size: cover'">
      <div class="m-page-mask" :class="currentPageBg.idx === 1 ? 'm-element-transparency-dark': 'm-element-transparency-light'">
        <div :class="currentPageBg.idx === 1 ? 'm-element-display': 'm-element-hide'">
          <div class="m-page-label banner-label">
            <span>实施成果</span>
          </div>
          <div class="m-page-title">智能过滤机</div>
          <div class="m-page-sub-title banner-sub-title">专业耐酸碱泵浦和精密化学药液过滤机生产商服务商</div>
          <div class="m-group">
            <div class="m-group-item">
              <div class="m-item-img left">
                <img src="../../../assets/img/case/case-precent-icon-01.png"/>
              </div>
              <div class="m-item-content">
                <div class="m-item-title">30%</div>
                <div class="m-item-sub-title">实时监测，快速排故障，节省设备故障修复时间</div>
              </div>
              <div class="clear"></div>
            </div>
            <div class="m-group-item">
              <div class="m-item-img left">
                <img src="../../../assets/img/case/case-precent-icon-02.png"/>
              </div>
              <div class="m-item-content">
                <div class="m-item-title">20%</div>
                <div class="m-item-sub-title">预测性维护，降低异常停机时间</div>
              </div>
              <div class="clear"></div>
            </div>
            <div class="m-group-item">
              <div class="m-item-img left">
                <img src="../../../assets/img/case/case-precent-icon-03.png"/>
              </div>
              <div class="m-item-content">
                <div class="m-item-title">40%</div>
                <div class="m-item-sub-title">用数据针对性维保换件，备件费用降低</div>
              </div>
              <div class="clear"></div>
            </div>
            <div class="m-group-item">
              <div class="m-item-img left">
                <img src="../../../assets/img/case/case-precent-icon-04.png"/>
              </div>
              <div class="m-item-content">
                <div class="m-item-title">5%</div>
                <div class="m-item-sub-title">数据智能监测，提升产品附加值</div>
              </div>
              <div class="clear"></div>
            </div>
          </div>
        </div>
        <div class="m-page-carousel">
          <el-carousel
            :autoplay="carousel.autoPlay"
            :indicator-position="carousel.indicatorPosition"
            type="card"
            height="108px"
            @change="choosePageBg">
            <el-carousel-item v-for="(item, index) in carouselImgList" :key="index">
              <div class="m-carousel-img-sign" v-if="item.idx === 1">
                <icon class="m-carousel-img-sign-icon" name="exclamation"></icon>
              </div>
              <img class="el-carousel-img" :src="item.icon" :class="currentPageBg.idx === item.idx ? 'el-carousel-img-active': ''"/>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="m-page-problem">
      <div class="m-page-label problem-label">
        <span>解决的问题</span>
      </div>
      <div class="m-problem-group">
        <div class="m-problem-group-item m-item-orange">
          <div class="m-p-g-item-title">已售设备当前状态一无所知</div>
          <div class="m-p-g-item-desc">设备分布各地，设备动态无法及时了解</div>
        </div>
        <div class="m-problem-group-item m-item-orange">
          <div class="m-p-g-item-title">设备运营数据无法掌控</div>
          <div class="m-p-g-item-desc">设备的能量产耗等关键数据无法监测</div>
        </div>
        <div class="m-problem-group-item m-item-orange">
          <div class="m-p-g-item-title">设备维修保养处于被动状态</div>
          <div class="m-p-g-item-desc">设备状况不能及时诊断分析维护，耗材的损耗信息不能为二次销售提供及时信息</div>
        </div>
        <div class="m-problem-group-item m-item-orange">
          <div class="m-p-g-item-title">设备同质化严重</div>
          <div class="m-p-g-item-desc">行业同质化严重，众厂家价格战白热化，设备销售缺乏竞争力；</div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
    <div class="m-page-solution">
      <div class="m-page-label solution-label">
        <span>我们如何做的</span>
      </div>
      <div class="m-page-diagram">
        <img src="../../../assets/img/case/case-mobile-diagram-01.png"/>
      </div>
      <div class="clear"></div>
    </div>
    <div class="clear"></div>
  </div>
</template>

<script>
import '../styles/mobile-page.scss'
export default {
  name: 'dJingMobilePage',
  data () {
    return {
      currentPageBg: {
        idx: 1,
        bg: require('../../../assets/img/case/case-page-bg-01.png')
      },
      carousel: {
        autoPlay: false,
        indicatorPosition: 'none'
      },
      carouselImgList: [
        {idx: 1, icon: require('../../../assets/img/case/glj/case-glj-page-bg-01.png'), bg: require('../../../assets/img/case/glj/case-glj-page-bg-01.png')},
        {idx: 2, icon: require('../../../assets/img/case/glj/case-glj-page-bg-02.jpg'), bg: require('../../../assets/img/case/glj/case-glj-page-bg-02.jpg')},
        {idx: 3, icon: require('../../../assets/img/case/glj/case-glj-page-bg-03.jpg'), bg: require('../../../assets/img/case/glj/case-glj-page-bg-03.jpg')},
        {idx: 4, icon: require('../../../assets/img/case/glj/case-glj-page-bg-04.jpg'), bg: require('../../../assets/img/case/glj/case-glj-page-bg-04.jpg')},
        {idx: 5, icon: require('../../../assets/img/case/glj/case-glj-page-bg-05.jpg'), bg: require('../../../assets/img/case/glj/case-glj-page-bg-05.jpg')},
        {idx: 6, icon: require('../../../assets/img/case/glj/case-glj-page-bg-06.jpg'), bg: require('../../../assets/img/case/glj/case-glj-page-bg-06.jpg')},
        {idx: 7, icon: require('../../../assets/img/case/glj/case-glj-page-bg-07.jpg'), bg: require('../../../assets/img/case/glj/case-glj-page-bg-07.jpg')},
        {idx: 8, icon: require('../../../assets/img/case/glj/case-glj-page-bg-08.jpg'), bg: require('../../../assets/img/case/glj/case-glj-page-bg-08.jpg')}
      ]
    }
  },
  methods: {
    choosePageBg (idx) {
      let data = this.carouselImgList[idx]
      this.currentPageBg.idx = data.idx
      this.currentPageBg.bg = data.bg
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/case/components/GLvJiMobilePage.vue